// pages/Preferred.tsx
import React from 'react';
import Icon from '@components/common/assets';
import Step1 from './step1';
import classnames from 'classnames/bind';
import styles from './commonStyle.module.scss';

const cx = classnames.bind(styles);

const Preferred = () => {
  return (
    <div className={cx('wrapper')}>
      <div className={cx('header')}>
        <div className={cx('logo')}>
          <Icon name="logo" width={80} height={18} />
          <span className={cx('hidden')}>JOBDA</span>
        </div>
      </div>

      <Step1 />
    </div>
  );
};

export default Preferred;
